import axios from "axios";

const API_URL = "/api/curriculum-subjects";

// Get all curriculum subjects with optional filtering
export const getCurriculumSubjects = async (params = {}) => {
  try {
    const { data } = await axios.get(API_URL, { params });
    return data;
  } catch (error) {
    console.error("Error fetching curriculum subjects:", error);
    throw error;
  }
};

// Get curriculum subjects by grade
export const getCurriculumSubjectsByGrade = async (gradeId) => {
  try {
    const { data } = await axios.get(`${API_URL}/grade/${gradeId}`);
    return data;
  } catch (error) {
    console.error(`Error fetching curriculum subjects for grade ${gradeId}:`, error);
    throw error;
  }
};

// Get single curriculum subject
export const getCurriculumSubject = async (id) => {
  try {
    const { data } = await axios.get(`${API_URL}/${id}`);
    return data;
  } catch (error) {
    console.error(`Error fetching curriculum subject ${id}:`, error);
    throw error;
  }
};

// Create new curriculum subject
export const addCurriculumSubject = async (payload) => {
  try {
    const { data } = await axios.post(API_URL, payload);
    return data;
  } catch (error) {
    console.error("Error adding curriculum subject:", error);
    throw error;
  }
};

// Update curriculum subject
export const editCurriculumSubject = async (id, payload) => {
  try {
    const { data } = await axios.put(`${API_URL}/${id}`, payload);
    return data;
  } catch (error) {
    console.error(`Error editing curriculum subject ${id}:`, error);
    throw error;
  }
};

// Delete curriculum subject
export const deleteCurriculumSubject = async (id) => {
  try {
    const { data } = await axios.delete(`${API_URL}/${id}`);
    return data;
  } catch (error) {
    console.error(`Error deleting curriculum subject ${id}:`, error);
    throw error;
  }
};

// Bulk-set a grade's curriculum in one call.
// subjects: [{ subject_id, is_mandatory }], mode: 'merge' | 'replace'
export const bulkSetGradeCurriculum = async (gradeId, subjects, mode = "merge") => {
  const { data } = await axios.post(`${API_URL}/grade/${gradeId}/bulk`, { subjects, mode });
  return data;
};

// Copy one grade's curriculum onto another.
export const copyGradeCurriculum = async (fromGradeId, toGradeId, overwrite = false) => {
  const { data } = await axios.post(`${API_URL}/copy`, {
    from_grade_id: fromGradeId,
    to_grade_id: toGradeId,
    overwrite,
  });
  return data;
};

